<template>
  <Dashboard title="Users">
    <div id="users">      
      <Button
        class="users--add-button"
        title="Add user"
        to=""
        active=true
        showAddIcon=true
        v-on:handleClick="handleModal(
          'Add user',
          '',
          '',
          '',
          [],
          false,
          0,
          0
        )"
      />

      <Table
        recordsfoundishidden=true
        :data="users"
        :isloading="isLoading"
      >
        <template v-slot:titles>
          <th>Name</th>
          <th>Access</th>
          <th></th>
        </template>

        <template v-slot:row>
          <tr
            class="table--content"
            v-for="(item, index) of users"
            v-bind:key="index"
          >
            <!-- user -->
            <TdUser
              :profileimage="item.profileImage"
              :name="item.displayname"
              :email="item.username"
              :isadmin="item.isAdmin"
            />

            <!-- access -->
            <TdAccess
              :access="item.access"
              :list="applications"
              :id="item.id"
            />

            <!-- buttons -->
            <TdButtons>
              <RoundedButton
                title="Edit"
                v-on:handleClick="handleModal(
                  'Save user',
                  item.username,
                  item.displayname,
                  item.image,
                  item.access,
                  item.isAdmin,
                  item.id,
                  index
                )"
              >
                <EditIcon/>
              </RoundedButton>

              <RoundedButton
                title=""
                danger=true
                v-if="currentUserId !== item.id"
                v-on:handleClick="handleDelete(index, item.id)"
              >
                <TrashIcon/>
              </RoundedButton>
            </TdButtons>
          </tr>
        </template>
      </Table>
    </div>

    <Modal
      id="modal-users"
      closeIcon="true"
      v-on:close="handleModal"
      v-if="!modal.isHidden"
    >      
      <template v-slot:title>
        <h3>{{ modal.title }}</h3>
      </template>

      <template v-slot:content>
        <form>
          <div class="row">
            <Input
              class="col-12"
              placeholder="Email"
              type="email"
              :value="modal.fields.username"
              v-model="modal.fields.username"
            />

            <Input
              class="col-12"
              placeholder="Display name"
              type="text"
              :value="modal.fields.displayname"
              v-model="modal.fields.displayname"
            />
            
            <!-- <Input
              class="col-12"
              placeholder="Profile image"
              type="file"
              :value="modal.fields.image"
            /> -->
            
            <!-- <div class="col-12">
              <Tag
                v-model="modal.fields.tagData"
                titleIsHidden="false"
                :value="modal.fields.tagData"
                :list="applications"
                :id="modal.fields.id"
              />
            </div> -->

            <div class="col-12 input">
              <p>Admin</p>

              <SwitchForm 
                :isActive="modal.fields.isAdmin"
                v-model="modal.fields.isAdmin"
              />
            </div>
          </div>

          <ButtonForm
            :title="modal.title"
            v-on:handleClick="handleModalButton()"
          />
        </form>
      </template>      
    </Modal>
  </Dashboard> 
</template>

<script>
  import { API } from '../../services/api.ts';
  import Dashboard from '../../components/dashboard/dashboard.vue'
  import Button from '../../components/buttons/button.vue'
  import RoundedButton from '../../components/buttons/roundedButton.vue'
  import Modal from '../../components/modal/modal.vue'
  import Input from '../../components/form/input.vue'
  import ButtonForm from '../../components/form/button.vue'
  import Tag from '../../components/form/tag.vue'
  import SwitchForm from '../../components/form/switch.vue'

  import Table from '../../components/table/table.vue'
  import TdUser from '../../components/table/td/user.vue'
  import TdAccess from '../../components/table/td/access.vue'
  import TdButtons from '../../components/table/td/buttons.vue'
  import TrashIcon from '../../icons/trash.vue'
  import EditIcon from '../../icons/edit.vue'

  export default {
    name: 'Users',
    components: {
      Dashboard,
      Button,
      RoundedButton,
      Modal,
      Input,
      ButtonForm,
      Tag,
      SwitchForm,
      Table,
      TdUser,
      TdAccess,
      TdButtons,
      TrashIcon,
      EditIcon
    },
    data () {
      return {
        isLoading: true,
        modal: {
          isHidden: true,
          title: '',
          fields: {
            username: '',
            displayname: '',
            image: '',
            tagData: [],
            isAdmin: false,
            id: 0,
            index: 0
          }
        },
        currentUserId: 0,
        users: [],
        applications: []
      }
    },
    methods: {
      handleModal: function(
        title,
        username,
        displayname,
        image,
        tagData,
        isAdmin,
        id,
        index
      ) {
        // fill modal data
        this.modal.title = title;
        this.modal.fields.username = username;
        this.modal.fields.displayname = displayname;
        this.modal.fields.image = image;
        this.modal.fields.tagData = tagData;
        this.modal.fields.isAdmin = isAdmin;
        this.modal.fields.id = id;
        this.modal.fields.index = index;

        // show / hide
        if (this.modal.isHidden === true) {
          this.modal.isHidden = false;
        } else {
          this.modal.isHidden = true;
        }
      },
      handleModalButton: function() {
        this.$el.querySelector('form').reportValidity();
        
        if (
          this.modal.fields.displayname !== ''
          && this.modal.fields.username !== ''
        ) {
          if (this.modal.title === 'Add user') {
            this.addUser()
          } else {
            this.editUser()
          }
        }
      },
      addUser: function() {
        // console.log(this.modal.fields);
        // console.log(this.users);

        let currentIds = [];

        for (const item of this.modal.fields.tagData) {
          currentIds.push(item.id);
        }

        API.post(
          'index.cfm?act=accounts.item',
          {
            username: this.modal.fields.username,
            displayname: this.modal.fields.displayname,
            // profileImage: this.modal.fields.image,
            addApplications: `${currentIds}`,
            isAdmin: this.modal.fields.isAdmin
          }
        ).then(
          response => {
            console.log(response);
            location.reload();
          }
        )
      },
      editUser: function() {
        API.patch(
          `index.cfm?act=accounts.item&id=${this.modal.fields.id}`,
          {
            username: this.modal.fields.username,
            displayname: this.modal.fields.displayname,
            profileImage: this.modal.fields.image,
            isAdmin: this.modal.fields.isAdmin
          }
        ).then(
          response => {
            this.users[this.modal.fields.index].username = response.data.data.username;
            this.users[this.modal.fields.index].displayname = response.data.data.displayname;
            this.users[this.modal.fields.index].image = response.data.data.profileImage;
            this.users[this.modal.fields.index].isAdmin = response.data.data.isAdmin;

            this.accounts();
            
            this.modal.isHidden = true;
          }
        )
      },
      handleDelete(index, id) {
        if (confirm("Are you sure you want to delete this user?")) {
          API.delete(
            `index.cfm?act=accounts.item&id=${id}`
          ).then (
            response => {
              console.log(response);
              this.users.splice(index, 1);
            }
          )
        }
      },
      accounts: function() {
        API.get(
          'index.cfm?act=accounts.list'
        ).then(
          response => {
            this.users = response.data.data
            console.log(this.users);
            this.isLoading = false
          }
        )
      }
    },
    mounted() {
      API.get(
        'index.cfm?act=accounts.me'
      ).then(
        response => {          
          this.currentUserId = response.data.data.id;
        }
      )

      this.accounts();
      
      API.get(
        'index.cfm?act=applications.list&view=all'
      ).then(
        response => (this.applications = response.data.data)
      )
    }
  }
</script>

<style lang="scss">
  #users {
    
    .users--add-button {
      float: right;
    }

    .table {
      float: left;
    }
  }

  #modal-users {
    
    .button-form {
      margin-top: 15px;
    }
  }
</style>
